import { Link } from 'react-router-dom';
import { LabResultList } from '../../components/lab-results/lab-result-list';

function LabResultsIndexPage() {
  return (
    <div className="p-8">
      <p>Lab Results</p>
      <Link to="/lab-results/create">
        <button type="button" className="px-8 py-2 shadow-lg text-blue hover:text-darkblue">
          Create
        </button>
      </Link>
      <hr className="my-5" />
      <LabResultList />
    </div>
  );
}

export default LabResultsIndexPage;
